import PushBundle from "../../assets/pushbundle.png";
import MultiVariants from "../../assets/multivariants.png";
import MdConverter from "../../assets/mdconverter.png";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";

export const projectsData = [
    {
        id: 1,
        image: MultiVariants,
        // Logos sit inside a light plate so transparent/dark artwork stays legible in both themes.
        fit: "contain",
        title: "MultiVariants – Bulk Order",
        description:
            "Shopify app that lets B2B and wholesale buyers order every variant combination from a single page, with table, grid and matrix layouts, min/max quantity rules and catalog pricing.",
        category: "shopify",
        tags: ["Shopify", "Laravel", "React"],
        rating: 4.9,
        reviews: 338,
        link: "https://apps.shopify.com/multivariants",
        linkLabel: "View on Shopify App Store",
    },
    {
        id: 2,
        image: PushBundle,
        fit: "contain",
        title: "Push Bundle – Build a Box",
        description:
            "Shopify bundling app for mix-and-match and build-a-box offers, with volume discounts, quantity breaks, cross-sells and free gifts — all configurable without code.",
        category: "shopify",
        tags: ["Shopify", "Laravel", "React"],
        rating: 4.9,
        reviews: 13,
        link: "https://apps.shopify.com/push-bundle/?ref=efolillc&utm_source=pushbundle_website&utm_medium=page&utm_campaign=homePage",
        linkLabel: "View on Shopify App Store",
    },
    {
        id: 3,
        image: MdConverter,
        fit: "contain",
        title: "MdConverter – Chrome Extension",
        description:
            "Converts any web page or selected section into clean Markdown in one click — stripping ads, nav and popups while preserving headings, tables and code blocks. Runs entirely in the browser with no account or tracking.",
        category: "extension",
        tags: ["JavaScript", "Chrome Extension"],
        link: "https://chromewebstore.google.com/detail/mdconverter/lfjdpkdniidojcdagfpnfccgihjoiipf",
        linkLabel: "View on Chrome Web Store",
    },
    {
        id: 4,
        image: Work4,
        fit: "cover",
        title: "HRM Application",
        description:
            "Human resource management platform covering employee records, attendance, leave workflows and payroll reporting.",
        category: "web",
        tags: ["Laravel", "MySQL", "React"],
        link: "",
    },
    {
        id: 5,
        image: Work5,
        fit: "cover",
        title: "Telemedicine Platform",
        description:
            "Remote consultation platform with appointment scheduling, secure patient records and video visits.",
        category: "web",
        tags: ["Laravel", "React", "WebRTC"],
        link: "",
    },
];

export const projectNav = [
    { name: 'all' },
    { name: 'shopify' },
    { name: 'web' },
    { name: 'extension' },
];
